module.exports = __webpack_public_path__ + "static/media/Krust the Clown.e37f46b6.png";